import { getNewBrands, getUploadedLogoPreview } from '@anm/helpers/branding';
import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { clearUploadedBrand, uploadBrandLogoAsync } from '../actions';
import { BrandActions, BrandState } from '../types';

import { initialBrandState } from '.';

const uploadBrandLogoReducer: Reducer<BrandState, BrandActions> = (state = initialBrandState, action) => {
  switch (action.type) {
    case getType(uploadBrandLogoAsync.request): {
      return {
        ...state,
        uploadBrandLogo: {
          ...state.uploadBrandLogo,
          isError: false,
          isPending: true,
          uploadedImageUrl: ''
        }
      };
    }
    case getType(uploadBrandLogoAsync.success): {
      return {
        ...state,
        brandsList: {
          ...state.brandsList,
          data: getNewBrands(action.payload, state.brandsList.data)
        },
        uploadBrandLogo: {
          ...state.uploadBrandLogo,
          uploadedImageUrl: getUploadedLogoPreview(action.payload),
          isPending: false
        }
      };
    }
    case getType(uploadBrandLogoAsync.failure): {
      return {
        ...state,
        uploadBrandLogo: {
          ...state.uploadBrandLogo,
          isError: true,
          isPending: false,
          error: action.payload
        }
      };
    }
    case getType(clearUploadedBrand): {
      return {
        ...state,
        uploadBrandLogo: initialBrandState.uploadBrandLogo
      };
    }
    default:
      return state;
  }
};

export default uploadBrandLogoReducer;
